module.exports = {
  visitEvents: {
    type: 'number',
    category: 'visitSession',
  },
  visitInteractions: {
    type: 'number',
    category: 'visitSession',
  },
  visitSearches: {
    type: 'number',
    category: 'visitSession',
  },
  visitTotalTime: {
    type: 'seconds',
    category: 'visitSession',
  },
  visitTotalActions: {
    type: 'number',
    category: 'visitSession',
  },
  visitEntryUrl: {
    type: 'url',
    category: 'visitSession',
  },
  visitEntryTitle: {
    category: 'visitSession',
  },
  visitExitUrl: {
    type: 'url',
    category: 'visitSession',
  },
  visitExitTitle: {
    category: 'visitSession',
  },
  visitGoalConverted: {
    type: 'boolean',
    category: 'visitSession',
  },
  visitorVisitCount: {
    type: 'number',
    category: 'visitor',
  },
  visitorSecondsSinceFirstVisit: {
    type: 'number',
    category: 'visitor',
  },
  visitorSecondsSinceLastVisit: {
    type: 'number',
    category: 'visitor',
  },
  visitorCountry: {
    type: 'country',
    category: 'visitor',
  },
  visitorCity: {
    category: 'visitor',
  },
  visitorLocalTime: {
    category: 'visitor',
  },
  deviceType: {
    type: 'deviceType',
    category: 'device',
  },
  deviceBrand: {
    type: 'deviceBrand',
    category: 'device',
  },
  deviceModel: {
    category: 'device',
  },
  deviceOs: {
    type: 'operatingSystem',
    category: 'device',
  },
  deviceOsVersion: {
    type: 'number',
    category: 'device',
  },
  deviceResolution: {
    category: 'device',
  },
  browserLocale: {
    type: 'locale',
    category: 'browser',
  },
  browserLanguage: {
    type: 'language',
    category: 'browser',
  },
  browserName: {
    type: 'browser',
    category: 'browser',
  },
  browserVersion: {
    type: 'number',
    category: 'browser',
  },
  browserCookies: {
    type: 'boolean',
    category: 'browser',
  },
  browserEngine: {
    category: 'browser',
  },
  referrerType: {
    type: 'referrerType',
    category: 'referrer',
  },
  referrerKeyword: {
    category: 'referrer',
  },
  referrerUrl: {
    category: 'referrer',
  },
  referrerName: {
    category: 'referrer',
  },
  campaignContent: {
    category: 'campaign',
  },
  campaignGroup: {
    category: 'campaign',
  },
  campaignKeyword: {
    category: 'campaign',
  },
  campaignMedium: {
    category: 'campaign',
  },
  campaignName: {
    category: 'campaign',
  },
  campaignSource: {
    category: 'campaign',
  },
  campaignId: {
    category: 'campaign',
  },
  campaignPlacement: {
    category: 'campaign',
  },
  pageviewUrl: {
    type: 'url',
    category: 'pageview',
  },
  pageviewPath: {
    type: 'path',
    category: 'pageview',
  },
  pagePathSegment: {
    type: 'pathSegment',
    category: 'pageview',
  },
  pageviewTitle: {
    category: 'pageview',
  },
  pageviewPosition: {
    type: 'number',
    category: 'pageview',
  },
  siteSearchCategory: {
    category: 'siteSearch',
  },
  siteSearchResults: {
    type: 'number',
    category: 'siteSearch',
  },
  eventUrl: {
    type: 'url',
    category: 'event',
  },
  eventUrlPath: {
    type: 'path',
    category: 'event',
  },
  eventCategory: {
    category: 'event',
  },
  eventAction: {
    category: 'event',
  },
  eventName: {
    category: 'event',
  },
  timeSpent: {
    type: 'seconds',
    category: 'performance',
  },
  timeSpentRefAction: {
    type: 'seconds',
    category: 'performance',
  },
  timeDomCompletion: {
    type: 'milliseconds',
    category: 'performance',
  },
  timeDomProcessing: {
    type: 'milliseconds',
    category: 'performance',
  },
  timeNetwork: {
    type: 'milliseconds',
    category: 'performance',
  },
  timeOnLoad: {
    type: 'milliseconds',
    category: 'performance',
  },
  timeServer: {
    type: 'milliseconds',
    category: 'performance',
  },
  timeTransfer: {
    type: 'milliseconds',
    category: 'performance',
  },
  conversionGoalId: {
    type: 'conversionGoal',
    category: 'conversion',
  },
  surveyRespondent: {
    type: 'boolean',
    category: 'survey',
  },
  surveyResponsePageUrl: {
    category: 'survey',
  },
  surveyResponsePageTitle: {
    category: 'survey',
  },
  surveyResponseClientPanel: {
    type: 'boolean',
    category: 'survey',
  },
};
